import Auth from './Auth'

export default Auth
export * from './Auth'



// WEBPACK FOOTER //
// ./src/legacy/containers/Auth/index.js